import { css } from '@emotion/react';
import { clearLastVisitedPage } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { TOP_BAR_HEIGHT, ICON_SIZE } from '../../constants';
import { signOut } from '../../helpers/sign-out';
import WeaveLogoDark from '../Weave-Logo-Dark.svg';

export const SimpleTopBar = () => {
  const { t } = useTranslation('base');
  return (
    <header
      css={css`
        align-items: center;
        background: ${theme.colors.white};
        display: flex;
        justify-content: space-between;
        max-height: ${TOP_BAR_HEIGHT}px;
        min-height: ${TOP_BAR_HEIGHT}px;
        padding: ${theme.spacing(1)};
      `}
    >
      <img src={WeaveLogoDark} alt='weave-app-logo' css={{ height: ICON_SIZE }} data-tour-guide='portal-logo' />
      <Button
        variant='tertiary'
        onClick={() => {
          clearLastVisitedPage();
          signOut();
        }}
      >
        {t('Sign Out')}
      </Button>
    </header>
  );
};
